import React, { forwardRef } from "react";
import classNames from "classnames";

import Bouton, { VARIANT } from "@/ui/bouton";
import Icon from "@/ui/icon";

import { Filtre } from "@/types/filtres";

import styles from "./dropdown.module.scss";

type FiltreDropdownButtonProps = {
    children?: React.ReactNode;
    filtre: Filtre;
    onClick: () => void;
    selectedCount: number;
    isOpen: boolean;
};

const FiltreDropdownButton = forwardRef<HTMLButtonElement, FiltreDropdownButtonProps>(
    ({ children, filtre, onClick, selectedCount, isOpen }, ref) => {
        return (
            <div data-component="Filtre" className={styles.filtre}>
                <Bouton
                    ref={ref}
                    className={classNames(styles.filtreButton, {
                        [styles.isOpen]: isOpen,
                    })}
                    variant={VARIANT.NONE}
                    onClick={onClick}
                >
                    {filtre.nom}
                    <small className={styles.notif}>{selectedCount}</small>
                    <Icon className={styles.icon} icon="fleche" />
                </Bouton>
                {children}
            </div>
        );
    },
);

type FiltreDropdownProps = {
    children: React.ReactNode;
    handleClear: () => void;
    handleClose: () => void;
    total: number;
};

const FiltreDropdown = forwardRef<HTMLDivElement, FiltreDropdownProps>(
    ({ children, handleClear, handleClose, total }, ref) => {
        return (
            <div ref={ref} className={styles.dropdown}>
                <div className={styles.dropdownContent}>{children}</div>
                <div className={styles.dropdownActions}>
                    <div className={styles.left}>
                        <Bouton
                            className={classNames(styles.buttonSecondary, styles.buttonDelete)}
                            color="dark"
                            onClick={handleClear}
                            variant={VARIANT.LINK}
                        >
                            Effacer les filtres
                        </Bouton>
                    </div>
                    <div className={styles.right}>
                        <Bouton onClick={handleClose} className={styles.buttonApply} count={total}>
                            Voir les résultats
                        </Bouton>
                    </div>
                </div>
            </div>
        );
    },
);

export { FiltreDropdown, FiltreDropdownButton };
